import { Component, ChangeDetectionStrategy } from '@angular/core';
import { map } from 'rxjs/operators';
import { ApplicationStateService } from '../../../../shared/services/application-state/application-state.service';
import { AsyncPipe } from '@angular/common';
import { UserStateService } from '../../../../../../modules/user/shared/services/user-state/user-state.service';
import { UserRole } from '../../../../../../core/enums/users/role';
import { UserMembershipStatus } from '../../../../../../core/enums/users/membership-status';
import { UserInformationService } from '../../../../../../modules/user/shared/services/user-information/user-information.service';
import { constructLicenseeName } from '../../../../shared/helpers/licensee-name/licensee-name.helper';

@Component({
    selector: 'app-frn-filing-header-info',
    templateUrl: './frn-filing-header-info.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [AsyncPipe],
})
export class FrnFilingHeaderInfoComponent {
    readonly applicationState$ = this.applicationStateService.applicationState$;
    readonly licenseeName$ = this.applicationState$.pipe(
        map((applicationState) => constructLicenseeName(applicationState)),
    );
    readonly appId$ = this.applicationState$.pipe(
        map((applicationState) => applicationState?.applicationId ?? null),
    );

    constructor(
        private readonly applicationStateService: ApplicationStateService,
        private readonly userStateService: UserStateService,
        private readonly userInformationService: UserInformationService,
    ) {}

    /**
     * Determines if EWA Staff fields should be displayed in the application header.
     */
    shouldShowEwaStaffHeaderFields(): boolean {
        const user = this.userStateService.getUser();
        if (!user) {
            return false;
        }

        return user.role !== UserRole.Customer;
    }

    /**
     * Validates whether the user's membership status is part of the acceptable statuses.
     */
    isActiveUserMembershipStatus(
        userMembershipStatus: UserMembershipStatus | null | undefined,
    ): boolean {
        return this.userInformationService.isActiveUserMembershipStatus(
            userMembershipStatus,
        );
    }

    /**
     * Formats the user membership status label for display in the EWA Staff Application Header.
     */
    getFormattedUserMembershipStatusLabel(
        userMembershipStatus: UserMembershipStatus | null | undefined,
    ): string {
        return this.userInformationService.getMembershipStatusLabel(
            userMembershipStatus,
        );
    }
}
